import { Button } from '@connected/ui/components/button';
import { Popout, PopoutBody, PopoutClose, PopoutContent, PopoutFooter, PopoutHeader, PopoutTitle } from '@connected/ui/components/popout';

export function ComingSoonModal({
    open,
    onOpenChange,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}) {
    return (
        <Popout open={open} onOpenChange={onOpenChange}>
            <PopoutContent>
                <PopoutHeader>
                    <PopoutTitle>Komt binnenkort</PopoutTitle>
                </PopoutHeader>
                <PopoutBody className="text-center">
                    <div>Aan deze functie wordt gewerkt. Heeft u ideeën en/of vragen neem gerust contact met ons op, tel. 085-2221669 of middels support@connected.nl</div>
                </PopoutBody>
                <PopoutFooter className="flex justify-end">
                    <PopoutClose asChild>
                        <Button variant="default">Sluiten</Button>
                    </PopoutClose>
                </PopoutFooter>
            </PopoutContent>
        </Popout>
    );
}
